import TableDefault from "../../../../components/grid/TableDefault";
import { formatDate } from "../../../../utils/formatDate";
import MaskService from "../../../../utils/mask/maskService";
import moment from "moment";

const BodySuggestions = ({
  suggestions = [],
  items = [],
  setItems = () => {},
}) => {
  return (
    <>
      <TableDefault
        selected={items || []}
        setSelected={setItems}
        smallFont
        selectable
        columns={[
          {
            label: "Data",
            id: "date",
            format: (item) => {
              let getStandardDate = !!item.date;

              if (getStandardDate)
                return moment(item.date).format("DD/MM/YYYY");
              else {
                return "-";
              }
            },
          },
          {
            label: "Descrição",
            id: "description",
          },
          {
            label: "Valor",
            id: "value",
            format: (item) =>
              `R$ ${MaskService.toMask(
                "decimal",
                parseFloat(item.value).toFixed(2)
              )}`,
          },
          {
            label: "Tipo",
            id: "tipo",
            format: (item) => {
              if (item.typeBill === "movimentationsBank") {
                return "MB";
              } else if (item.typeBill === "accountsPay") {
                return "CP";
              } else if (item.typeBill === "accountsReceivable") {
                return "CR";
              } else {
                return "-";
              }
            },
          },
          {
            label: "Situação",
            id: "status",
          },
        ]}
        values={suggestions}
        rowId="typeBillID"
        customDisableCheckAll={true}
      />
    </>
  );
};

export default BodySuggestions;
